import { Sparkles, MessageCircle, BadgePercent } from "lucide-react";
import Reveal from "@/components/Reveal";
import ResortCard from "@/components/ResortCard";
import { RESORTS } from "@/data/resorts";

export default function ResortsCatalog({ onQuote }) {
    return (
        <section id="explore-resorts" className="bg-sand py-24 sm:py-32" data-testid="resorts-catalog-section">
            <div className="mx-auto max-w-7xl px-4 sm:px-6">
                <Reveal>
                    <div className="flex flex-wrap items-end justify-between gap-6">
                        <div>
                            <p className="text-xs font-semibold uppercase tracking-[0.22em] text-gold-hover">Catálogo</p>
                            <h2 className="mt-3 font-serif text-3xl font-semibold tracking-tight text-forest-deep sm:text-4xl lg:text-5xl">
                                Explore os Resorts
                            </h2>
                            <p className="mt-4 max-w-2xl text-base leading-relaxed text-stone-600">
                                Nossa curadoria de destinos para férias em família, escapadas a dois e eventos.
                                Escolha o seu e receba a cotação personalizada.
                            </p>
                            <p className="mt-4 inline-flex items-center gap-2 rounded-full bg-gold/15 px-5 py-2.5 text-xs font-semibold text-gold-hover">
                                <BadgePercent className="h-4 w-4" />
                                Condições diferenciadas para quem solicita sua cotação pelo portal
                            </p>
                        </div>
                        <span className="inline-flex items-center gap-2 rounded-full border border-gold/40 bg-gold/10 px-5 py-2.5 text-xs font-semibold text-gold-hover">
                            <Sparkles className="h-4 w-4" />
                            Novos destinos em breve
                        </span>
                    </div>
                </Reveal>

                <div className="mt-14 grid grid-cols-1 gap-8 md:grid-cols-2">
                    {RESORTS.map((resort, i) => (
                        <Reveal key={resort.slug} delay={(i % 2) * 0.12}>
                            <ResortCard resort={resort} onQuote={onQuote} />
                        </Reveal>
                    ))}
                </div>

                <Reveal delay={0.15} className="mt-10">
                    <div
                        className="flex flex-col items-center justify-between gap-5 rounded-3xl border-2 border-dashed border-[#D5CCA8] bg-white/60 px-8 py-8 text-center sm:flex-row sm:text-left"
                        data-testid="resort-card-coming-soon"
                    >
                        <div>
                            <h3 className="font-serif text-xl font-semibold text-forest-deep">Não encontrou o destino ideal?</h3>
                            <p className="mt-1.5 text-sm leading-relaxed text-stone-600">
                                Conte o perfil da sua viagem e nossa equipe recomenda o resort perfeito para você.
                            </p>
                        </div>
                        <button
                            type="button"
                            data-testid="catalog-recommendation-btn"
                            onClick={() => onQuote("outro")}
                            className="inline-flex shrink-0 items-center gap-2 rounded-full bg-forest-emerald px-6 py-3.5 text-sm font-semibold text-white shadow-lg shadow-forest-deep/20 transition-all duration-200 hover:-translate-y-px hover:bg-forest-dark active:scale-[0.98]"
                        >
                            <MessageCircle className="h-4 w-4" />
                            Quero uma recomendação
                        </button>
                    </div>
                </Reveal>
            </div>
        </section>
    );
}
